export enum CustomizationPropertyName {
  EmailSenderDomain = 'email_sender_domain',
  EmailFromDisplayName = 'email_from_display_name',
  EmailFromAddressLocalPart = 'email_from_address_local_part',
  EmailReplyToDisplayName = 'email_reply_to_display_name',
  EmailReplyToAddressLocalPart = 'email_reply_to_address_local_part',
  EmailDoNotReplyToDisplayName = 'email_do_not_reply_to_display_name',
  EmailDoNotReplyToAddressLocalPart = 'email_do_not_reply_to_address_local_part',
  ApplicationBaseUrl = 'application_base_url',
  WebsiteUrl = 'website_url',
  HideBranding = 'hide_branding',
  HideIntegrations = 'hide_integrations'
}
